/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 수명인자 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../../recoil/menuState';
import { userInfoLoginState } from "../../../recoil/userState";
import clog from "../../../utils/logUtils";
import DeviceLifeTree from "./DeviceLifeTree";
import DeviceLifeCRUD from "./DeviceLifeCRUD";
/**
* @brief EHP 설비수명  - 수명인자 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DeviceLifeMain(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const setParentPopWin = props.setPopWin;
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("LIFE"); // LIFE,REPORT
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH
    const [workMode, setWorkMode] = useState("READ");
    const [reWork, setReWork] = useState(null);
    const [nodata, setNodata] = useState();
    /*    // option 선택 시  값 변경 액션
       function selectTabOption(optionElement) {
           const selectBox = optionElement.closest(".select");
           const selectedElement = selectBox.querySelector(".selected-value ");
           selectedElement.textContent = optionElement.textContent;
           var optionData = optionElement.getAttribute("data-value");
           selectedElement.setAttribute("data-value", optionData);
           clog("OPT VAL : " + optionElement.value);
   
           defaultCurTree();
           setParentCurTabMenu(JSON.parse(optionData)); // 탭 또는 모바일 경우
           //resetSearchParams();
       } */
    /* function onClickTab(e) {
        var actTag = (e.target.tagName === "DIV") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo)
        //clog("TAB : " + JSON.stringify(tabInfo));
        //setAdminType(tabInfo.adminType);
        /*      if (curTabMenu.tabType === "TAB_DEVICE") {
                 // setAdminType("ZONE");
                 setWorkMode("READ");
                 defaultCurTree();
             } else {
     
             }
        defaultCurTree();

        setParentCurTabMenu(tabInfo);
    } */
    /*     const defaultCurTree = () => (setSelTree({
            company: { companyId: "", companyName: "" },
            zone: { zoneId: "", zoneName: "" },
            subZone: { subZoneId: "", subZoneName: "" },
            room: { roomId: "", roomName: "" },
            spg: { spgId: -1, spgName: "" },
            reload: false
        })); */
    const defaultTree = {
        company: { companyId: "", companyName: "" },
        zone: { zoneId: "", zoneName: "" },
        subZone: { subZoneId: "", subZoneName: "" },
        room: { roomId: "", roomName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    useEffect(() => {
        setReWork(selTree);
    }, [selTree]);
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container admin-site", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""} ` },
                    React.createElement("div", { className: `box__body ${(nodata <= 0) ? "nodata" : ""}` },
                        React.createElement("section", { className: "swiper-section" },
                            React.createElement("div", { className: "swiper-container mySwiper" },
                                React.createElement("div", { className: "swiper-wrapper" },
                                    React.createElement("div", { className: "swiper-slide tab on", "data-tab": "tab-1" },
                                        React.createElement("p", null, curTabMenu.tabName))))),
                        React.createElement("div", { id: "tab-1", className: "tabcontent current" },
                            React.createElement(DeviceLifeTree, { selTree: selTree, setSelTree: handleSelTree, adminType: adminType, setAdminType: setAdminType }),
                            (adminType == "LIFE") &&
                                React.createElement(DeviceLifeCRUD, { selTree: selTree, setSelTree: handleSelTree, adminType: adminType, setAdminType: setAdminType, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin, setNodata: setNodata, reWork: reWork, setReWork: setReWork }))))))));
}
export default DeviceLifeMain;
